import React from 'react';
import { Box, Button, Typography, Card, CardContent } from '@mui/material';

const UserTypeSelection = ({ onSelectType }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 3,
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          borderRadius: 3,
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        }}
      >
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}>
            Welcome to Dhandhapaani
          </Typography>
          <Typography
            variant="caption"
            sx={{ display: 'block', mb: 2, color: 'text.secondary', letterSpacing: '0.06em', textTransform: 'uppercase' }}
          >
            Powered by Maruti Agritech
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
            Choose how you'd like to use our platform
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => onSelectType('business-owner')}
              sx={{
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5855eb 0%, #9333ea 100%)',
                },
              }}
            >
              🏢 Business Owner
            </Button>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
              Manage your business, track inventory, sales, and more
            </Typography>

            <Button
              variant="contained"
              size="large"
              onClick={() => onSelectType('customer')}
              sx={{
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                },
              }}
            >
              🛍️ Customer
            </Button>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Browse products, shop online, and manage orders
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserTypeSelection;


